<template>

  <div class="step_inner">
   
    <el-form ref="form" :model="formData"  :rules="rules" label-width="120px">
      <el-row  >
        <el-col :span="12">
          <el-form-item label="简历名称" prop="name">
                <el-input placeholder="请输入简历名称" v-model="formData.name"></el-input>
          </el-form-item>
         </el-col>

         <el-col :span="12">
          <el-form-item label="是否公开" prop="status">
              <el-switch
                v-model="formData.status"
                active-color="#13ce66"
                inactive-color="#c7c7c7"
                :active-value="1"
                :inactive-value="2">
              </el-switch>
          </el-form-item>
         </el-col>

      
      </el-row>
      <h2>1.基本信息</h2>

      <el-row  >
        <el-col :span="12">
          <el-form-item label="姓名" prop="resume_name">
            <el-input placeholder="请输入姓名" v-model="formData.resume_name"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="年龄" prop="resume_age">
            <el-input-number v-model="formData.resume_age" placeholder="年龄" ></el-input-number>
          </el-form-item>
        </el-col>
        
     </el-row>   

     <el-row  >
        <el-col :span="12">
          <el-form-item label="性别" prop="resume_sex" clearable>

            <el-select v-model="formData.resume_sex" placeholder="请选择" clearable>
                <el-option label="保密" :value="0"></el-option>
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
          </el-form-item>
        </el-col>
     </el-row>  


     <el-row  >
        <el-col :span="12">
          <el-form-item label="电话" prop="resume_mobile">
            <el-input placeholder="请输入电话" v-model="formData.resume_mobile"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="邮箱" prop="resume_email">
            <el-input placeholder="请输入邮箱" v-model="formData.resume_email"></el-input>
          </el-form-item>
        </el-col>
        
     </el-row>  

    

     <el-row  >
        <el-col :span="12">
          <el-form-item label="身份" prop="resume_identity">

            <el-select v-model="formData.resume_identity" placeholder="请选择" clearable>
              <el-option label="请选择" :value="0"></el-option>
                <el-option label="职场人" :value="1"></el-option>
                <el-option label="自由职业" :value="2"></el-option>
                <el-option label="在校生" :value="3"></el-option>
              </el-select>

          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="工作状态" prop="job_state">

              <el-select v-model="formData.job_state" placeholder="请选择" clearable>
                <el-option label="请选择" :value="0"></el-option>
                <el-option label="在职" :value="1"></el-option>
                <el-option label="考虑" :value="2"></el-option>
                <el-option label="离职" :value="3"></el-option>
              </el-select>

          </el-form-item>
        </el-col>
     </el-row>  



     <el-row  >
        <el-col :span="12">
          <el-form-item label="实践经验" prop="is_experience" clearable>
            <el-select v-model="formData.is_experience" placeholder="请选择">
              <el-option label="有" :value="1"></el-option>
              <el-option label="无" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="专业技能" prop="skill" >
            <el-input placeholder="请输入专业技能" v-model="formData.skill"></el-input>
          </el-form-item>
        </el-col>
     </el-row>  

     <el-row  >
        <el-col :span="12">
          <el-form-item label="毕业院校" prop="school">
            <el-input placeholder="请输入毕业院校" v-model="formData.school"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="籍贯" prop="native_place">
            <el-input placeholder="请输入籍贯" v-model="formData.native_place"></el-input>
          </el-form-item>
        </el-col>
        
     </el-row>  
    

      <el-form-item label="头像" prop="resume_logo">
            <imageUpload v-model="formData.resume_logo"/>
     </el-form-item>

     <!-- <el-form-item label="照片" prop="resume_imgs">
          <el-upload
            class="upload"
            :action="uploadFileUrl"
            :on-remove="(files) => handleRemove(files)"
            :on-success="(response, files) => uploadFileSuccess(response, files)"
            :on-error="uploadFileError"
            :file-list="formData.photoFiles"
            list-type="picture-card"
            >
              <i class="el-icon-plus"></i>
          </el-upload>
      </el-form-item>-->



      <el-form-item label="自我介绍" prop="introduce">
            <el-input type="textarea" v-model="formData.introduce" placeholder="请输入自我介绍"></el-input>
      </el-form-item>
      <el-form-item label="工作经历" prop="job_log">
        <el-button type="primary" plain @click="addJobLog">添加工作经历</el-button>
      </el-form-item>
      <div style="margin-left: 120px;"  >
        <el-table :data="formData.job_log" style="width:100%">
            <el-table-column   prop="start_date" label="工作时间">
                <template slot-scope="scope">
                  <el-form-item :prop="'job_log.' + scope.$index +'.start_date'"  label-width="0px"	>

                    <el-row  >
                      <el-col :span="12">
                        <el-date-picker  v-model="scope.row.start_date"  type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">    </el-date-picker>
                      </el-col>
                      <el-col :span="12">
                        <el-date-picker  v-model="scope.row.end_date"  type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                      </el-date-picker>
                      </el-col>
                    </el-row>    
                     
                  </el-form-item>
              </template>
            </el-table-column>
            <el-table-column   prop="company" label="工作单位">
                <template slot-scope="scope">
                  <el-form-item :prop="'job_log.' + scope.$index +'.company'"   label-width="0px"	>
                      <el-input v-model="scope.row.company" placeholder="请输入工作单位"/>
                  </el-form-item>
              </template>
            </el-table-column>
            <el-table-column  label="操作"  fixed="right" align="center" class-name="small-padding fixed-width" width="100">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="deleteRow(scope.$index, formData.job_log)"  type="text"  size="small">
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

      </div>
       

    <h2>2.求职信息</h2>
    <el-row >
      <el-col :span="12">
          <el-form-item label="期待岗位" prop="expect_job">
            <el-input placeholder="请输入期待工作" v-model="expect_jobs" @focus="showCategory"></el-input>
          </el-form-item>
        </el-col>
     </el-row>
     <el-row>
      <el-col :span="12">
          <el-form-item label="薪资类型" prop="salary_type">
            <el-select  v-model="formData.salary_type" placeholder="请选择"
                clearable
                filterable
                style="width:100%"
              >
                <el-option label="时" :value="1"></el-option>
                <el-option label="天" :value="2"></el-option>
                <el-option label="周" :value="3"></el-option>
                <el-option label="月" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="期待薪资" prop="expect_salary">
            <el-input placeholder="期待薪资" v-model="formData.expect_salary"></el-input>
          </el-form-item>
        </el-col>
        
     </el-row>  
     <el-form-item label="意向地区" prop="expect_address">
            <el-input placeholder="意向地区" v-model="formData.expect_address"></el-input>
     </el-form-item>

      <div style="text-align:center;margin: 20px;">
        <el-button type="primary" @click="handleNextStep">提交</el-button>
      </div>

    </el-form>
    <multi-category-dialog ref="refCategory"  @setClassItems="setClassItems"></multi-category-dialog>

  </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import urlConfig from '@/api/config'
import MultiCategoryDialog from '@/components/category/multi-category-dialog.vue';

export default {
  components: {
    ImageUpload,MultiCategoryDialog
  },

  props: {
    // 值
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    info: {
      type: Object,
      default: () => {},
    },
   
  },

  data () {
    return {
      projectDataList:[],
      uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址
      expect_jobs:"",
      formData:  {
        
        resume_mobile:'',//
        resume_email:'',//
        school: '',
        native_place: '',
        resume_identity:'',//
        job_state:'',//
        is_experience:null,//
        expect_job:[],//
        expect_salary:'',
        expect_salary_day:'',
        expect_salary_week:'',
        expect_salary_month:'',
        job_log:[
            {
            start_date:null,
            end_date:null,
            company:""
            
          }
        ],//地址信息
        skill:'',//
        introduce:'',//
        resume_imgs:'',//
        resume_name:'',//
        resume_sex:'',//
        resume_age:'',//
        photoFiles:[],//
        resume_imgs	:[],
        resume_logo:'',//
        expect_address:'',
        salary_type:'',//
        status:2,//
        name:'',//
        resume_id:"",

      },
      rules: {
        name: [
          { required: true, message: '简历名称', trigger: 'blur' }
        ],

        resume_name: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ],

        resume_sex: [
          { required: true, message: '请填写性别', trigger: 'change' }
        ],
        

        resume_age: [
          { required: true, message: '请填写年龄', trigger: 'blur' }
        ],

        resume_mobile: [
          { required: true, message: '请填写电话', trigger: 'blur' }
        ],

        expect_job: [
          { required: true, message: '请填写期待工作', trigger: 'change' }
        ],
        
      }

    }
  },

  created(){
   
   
  },
  mounted () {

    if(this.$route.query&&this.$route.query.resume_id){
      this.formData.resume_id=this.$route.query.resume_id;
    }
   
  },
  methods:{

    showCategory(){
      this.$refs.refCategory.init( this.formData.expect_job);
    },

    setClassItems(selectedList){
      console.log(selectedList);

      this.formData.expect_job=selectedList;
      var selectStrs=[];
      for (let item of selectedList ) {
        selectStrs.push(item.label)
      }

      this.expect_jobs=selectStrs.join(",");
     
      this.$forceUpdate();
      
    },

    setParams(obj){
      var that=this;
      this.formData=obj;
      if(!obj.job_log||!Array.isArray(obj.job_log)){
        this.formData.job_log=[];
      }
      

     /* var photoFiles=[];
      for (let item of that.formData.resume_imgs) {
        var file={
          name:"1111", url:item,
        }
          photoFiles.push(file);
      }

        that.formData.photoFiles=photoFiles;*/


        
      var selectStrs=[];
      for (let item of this.formData.expect_job ) {
        selectStrs.push(item.label)
      }
      this.expect_jobs=selectStrs.join(",");
    },


    deleteRow(index, rows) {
        rows.splice(index, 1);
    },

    addJobLog(){
      this.formData.job_log.push({
        start_date:null,
        end_date:null,
        company:""
        
      })
    },


    // 上传失败
    uploadFileError(err) {
      this.$message.error("上传失败, 请重试");
    },

    // 删除文件
    handleRemove(files) {
      console.log(files)
      var index =  this.formData.photoFiles.indexOf(files)
      this.formData.photoFiles.splice(index, 1);
      this.formData.resume_imgs.splice(index, 1);
     
    },
  

     // 上传成功的钩子函数
     uploadFileSuccess(response, files) {
      console.log(response);
      if(response.code==1){
        var file={
          name:response.filename, url:response.file,
        }
        this.formData.photoFiles.push(file);
        this.formData.resume_imgs.push(response.file);
      }
      
    },

    
    // 点击下一步
    handleNextStep() {

     // this.$emit('handleNextStep',this.formData);
     
     this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit('handleNextStep',this.formData);
        }

      });
    }
  }
}
</script>


<style lang="scss" scoped>
.step_inner {
  h2 {
    margin: 0;
    font-size: 19px;
    line-height: 50px;
  }

}
</style>